import { Component, Input } from "@angular/core";

@Component({
  selector: "app-chart-tab",
  template: `
    <div [hidden]="!active">
      <ng-content></ng-content>
    </div>
  `,
})
export class ChartTabComponent {
  @Input() public title!: string;
  public active = false;
}
